
import React, { PropsWithChildren, ReactElement } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './CorporateNavigationLinks.css';
import { Col, Image, Row, Section, Title } from '../../importCL';
import { useWidthContext } from '../../providers/Width';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

type TNavLinks = {
    cardTitle?: string;
    cardSubheading?: string;
    desktopCardImage?: string;
    mobileCardImage?: string;
    cardAltText?: string;
    cardCtaText: string;
    cardCtaUrl: string;
}
export interface ICorporateNavigationLinksProps extends MappedComponentProperties {
    title?: string;
    subtitle?: string;
    backgroundColor?: 'white' | 'light-grey' | 'light-blue';
    cardAlignment?: 'left'| 'right';
    imageFlush?: boolean;
    cards?: TNavLinks[];
}

export const CorporateNavigationLinksEditConfig = {
    emptyLabel: 'Corporate Navigation Links',
    isEmpty: (props: PropsWithChildren<ICorporateNavigationLinksProps>) => {
        return !props || !props.title;
    }
};

const CorporateNavigationLinks = (props: PropsWithChildren<ICorporateNavigationLinksProps>): JSX.Element => {
    const {title = '', subtitle = '', cards = [], cardAlignment = 'left', backgroundColor = 'white', imageFlush = false} = props;
    const {width} = useWidthContext();
    const minLength = Math.min(cards.length, 6);


    const CardContent = (): ReactElement[] => {
        if(!cards || !cards.length) {
            return [];
        }
        const flushImgRight = imageFlush && cardAlignment === 'left' ? '!pl-0 !py-0': '';
        const flushImgLeft = imageFlush && cardAlignment === 'right' ? '!pr-0 !py-0': '';
        
        return (cards).slice(0, minLength).map((card) => {
            return (
            <div className={`min-h-[5.5rem] max-h-[8.75rem] w-[22.5rem] md:w-full flex gap-4 bg-white p-4 border border-solid border-[#BEBEBE]
            ${cardAlignment === 'left' ? 'flex-row': 'flex-row-reverse'}
            ${flushImgLeft} ${flushImgRight}`}>
                    <Image 
                        className={`w-[10rem] min-w-[10rem] min-h-[6.375rem] max-h-[6.375rem] ${imageFlush ? 'w-full max-h-full': ''}`}
                        src={width > 769 ? card.desktopCardImage : card.mobileCardImage}
                        alt={card.cardAltText}
                    />
                    <div className={`w-full h-full flex flex-col justify-center`}>
                        {card.cardTitle && <h5>{card.cardTitle}</h5>}
                        {card.cardSubheading && <span className='mb-2'>{card.cardSubheading}</span>}
                        <div>
                        {card.cardCtaText && card.cardCtaUrl && 
                        <ButtonWrapper href={card.cardCtaUrl} variant={'link'} size='medium' className={'!p-0 !m-0 !text-left !border-0'}>
                            {card.cardCtaText}
                        </ButtonWrapper>}
                        </div>
                    </div>
            </div>)
        })
    };

    return (<>
        <Section className={`CorporateNavigationLinks w-full h-full flex items-center !py-8`} bgColor={backgroundColor}>
                <Row className={`${minLength === 1 ? 'min-md:flex-nowrap': ''}`} justify='center'>
                    <Col md={minLength === 1 ? 6: 4}>
                    <Title
                        tag={'h2'}
                        showHr={true}
                        align={'left'}
                        spanTitle={transformHTMLParserLinks(subtitle)}
                        verticalBar={true}
                    >
                        {transformHTMLParserLinks(title)}
                    </Title>
                    </Col>
                    <Col lg={minLength === 1 ? 6 : 8} className={`CorporateNavigationLinks__cardContainer flex flex-wrap gap-2 md:justify-center md:items-center md:flex-col md:min-w-fit ${minLength === 1 ? 'justify-center': ''}`}>
                       {CardContent()}
                    </Col>
                </Row>
        </Section>
    </>);
};

export default CorporateNavigationLinks;
        